import React from 'react';
import PropTypes from 'prop-types';

import { Label } from 'core/components/label';
import useStyles from './modal-header.styles';

const ModalHeader = ({ address }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Label type="h1">We found lenders in our database that match the lender you added</Label>
      <div className={classes.description}>
        <Label type="body1" className={classes.title}>
          Which lender should we use for {address}?
        </Label>
      </div>
    </div>
  );
};

ModalHeader.propTypes = {
  address: PropTypes.string.isRequired
};

export default ModalHeader;
